import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getTypeList({ commit }) {
    try {
      const { records } = (await API.get('/connections/type/getList')).data.data;
      commit(FILL_LIST, { records });
    } catch (err) {
      console.log(err);
    }
  },
};
